module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_1.0031191e.jpg";